/**
 * @see https://umijs.org/docs/max/access#access
 * */
/*
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
  };
}
*/
// src/access.ts

/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
/*
export default function access(initialState: { currentUser?: API.CurrentUser; permissions?: string[] } | undefined) {
  const { permissions } = initialState ?? {};
  
  // 将权限列表转换为一个 map，方便快速查找
  const accessMap: { [key: string]: boolean } = {};
  if (permissions) {
    permissions.forEach(p => {
      accessMap[p] = true;
    });
  }

  return {
    // 这里的 key 需要和 routes.ts 中的 access 字段对应
    // 例如： access: 'system' 就会调用这里的 system() 函数
    // antd pro 内置的
    canAdmin: accessMap['canAdmin'] || false,
    
    // 我们自定义的权限
    system: accessMap['system'] || false,
    'system:user': accessMap['system:user'] || false,
    'system:role': accessMap['system:role'] || false,
    'system:permission': accessMap['system:permission'] || false,

    // 也可以定义一个通用的权限检查函数
    canSee: (p: string) => accessMap[p] || false,
  };
}
*/

// src/access.ts

export default function access(
  initialState:
    | { currentUser?: API.CurrentUser; permissions?: string[] }
    | undefined,
) {
  const { permissions } = initialState ?? {};

  // 将权限列表转换为一个 map，方便快速查找，性能更好
  const accessMap: { [key: string]: boolean } = {};
  if (permissions) {
    permissions.forEach((p) => {
      accessMap[p] = true;
    });
  }

  return {
    // ✨ 核心改动：将权限 map 直接展开，这样所有权限都会被自动映射
    ...accessMap,

    // antd pro 内置的，可以保留也可以删除，如果你的后端不返回 'canAdmin' 这个key
    canAdmin: !!accessMap['canAdmin'],

    // 你原有的通用函数也可以保留，在某些复杂场景下可能有用
    // 甚至可以简化成这样，因为 accessMap 已经处理了 undefined 的情况
    can: (p: string) => !!accessMap[p],
    // 也可以定义一个通用的权限检查函数
    canSee: (p: string) => accessMap[p] || false,
  };
}
